import { createBrowserHistory } from 'history'
import { map, compose, complement, allPass } from 'ramda'

import { ROUTE_SCROLL_EXCEPTIONS } from './constants/RouteScrollExceptions'

const browserHistory = createBrowserHistory()

/** @deprecated - history should not be used from here */
export const history = browserHistory

history.listen(({ location: { pathname } }) => {
  try {
    const pathnameRequirements = map(
      compose(complement),
      ROUTE_SCROLL_EXCEPTIONS,
    )

    if (allPass(pathnameRequirements)(pathname || '')) {
      window.scrollTo(0, 0)
    }
    // eslint-disable-next-line no-empty
  } catch (e) {}
})
